<template>
    <v-card>
        <v-snackbar
          v-model="showErr"
          multi-line
          :timeout="3000"
          top
          :color="errCode==0?'success':''"
        >
          {{ errMsg }}
          <template v-slot:action="{ attrs }">
            <v-btn
              :color="errCode==0?'':'red'"
              text
              v-bind="attrs"
              @click.prevent.stop="showErr = false"
            >
              close
            </v-btn>
          </template>
        </v-snackbar>
        <v-toolbar
          dark
          color="primary"
          class="flex-grow-0"
        >
          <v-toolbar-title>Settings</v-toolbar-title>
        </v-toolbar>
        <v-list
          two-line
          subheader
        >
          <v-subheader>Screen Settings</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-btn  :width="125" :max-width="125" tile @click="()=>{settingControl('setting', 'onoff',reply=>chkReplyErr(reply))}" >
                on/off
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Show screen settings</v-list-item-title>
            </v-list-item-content> 
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-btn :width="125" :max-width="125" tile color="primary" @click="getEiSettings">Get</v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Get screen settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field solo v-model="settingEiName" hide-details placeholder="EiName"></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field solo v-model="settingEiTag" hide-details placeholder="EiTag"></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-btn :width="125" :max-width="125" tile color="primary" @click="setEiSettings">Save</v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Save screen settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list
          two-line
          subheader
        >
          <v-subheader>Console Settings</v-subheader>
          <v-list-item>
              <v-list-item-action>
                <v-btn :width="125" :max-width="125" tile @click="()=>{touchControl('console', 'onoff',reply=>chkReplyErr(reply))}" >
                    on/off
                  </v-btn>
              </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Show console</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
                <v-btn fab @click="()=>{touchControl('console','scrollup',result=>chkReplyErr(result))}">
                    <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
            </v-list-item-action>
            <v-list-item-action>
                <v-btn fab @click="()=>{touchControl('console','scrolldown',result=>chkReplyErr(result))}">
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
                <v-btn :width="125" :max-width="125" tile color="primary" @click="()=>{touchControl('console','clear',result=>chkReplyErr(result))}">Clear</v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Clear console</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list
          two-line
          subheader
        >
            <v-subheader>Screen on startup</v-subheader>
            <v-list-item>
              <v-list-item-action>
                  <v-checkbox  v-model="enableStartupEvent" @change="SetStartEnable" >
                    </v-checkbox>
                </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Enable startup event</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              append-icon="none"
            >
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-btn :width="125" :max-width="125" tile :color="startcmd_droplast?'primary':'grey'">Drop Last</v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Drop last when startup</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item >
                    <v-text-field solo placeholder="Delay" class="mr-4" hide-details v-model="dropLastDelay"></v-text-field>
                    <v-btn :width="125" :max-width="125" tile color="blue lighten-4" @click="dropLast">save</v-btn>
                </v-list-item>
            </v-list-group>
            <v-list-group
              append-icon="none"
            >
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-btn :width="125" :max-width="125" tile :color="startcmd_dropurl?'primary':'grey'">Drop Urls</v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Drop urls when startup</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-for="(item,index) in dropUrls" :key="index">
                    <v-text-field 
                        solo 
                        placeholder="Url" 
                        class="mr-4" 
                        hide-details 
                        append-outer-icon="mdi-close"
                        v-model="dropUrls[index]"
                        @click:append-outer="deleteItem(dropUrls,index)"
                    ></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-btn :width="125" :max-width="125" tile color="green accent-2" @click="dropUrls.push('')">Add Url</v-btn>
                </v-list-item>
                <v-list-item class="row no-gutters">
                    <v-text-field 
                        solo 
                        placeholder="Sec" 
                        hide-details
                        v-model="dropUrlDuration"
                        type="number"
                        class="col mr-2 col-xs-12 col-6"
                    ></v-text-field>
                    <v-select class="col col-xs-12 col-4 mr-2" 
                    solo 
                    hide-details 
                    v-model="dropUrlMode" 
                    :items="['Normal','Loop','Random']" 
                    label="Play mode"
                    ></v-select>
                    <v-btn :width="125" :max-width="125" tile class="col col-xs-12 col-2" color="blue lighten-4" @click="dropUrl">save</v-btn>
                </v-list-item>
            </v-list-group>
            <v-list-group
              append-icon="none"
            >
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-btn :width="125" :max-width="125" tile color="primary">Set Logo</v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Set logo when startup</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item >
                    <v-text-field v-model="setLogoUrl" solo placeholder="Url" class="mr-4" hide-details></v-text-field>
                    <v-btn :width="125" :max-width="125" class="mr-2" color="blue lighten-4" tile @click="SetLogo(setLogoUrl)">save</v-btn>
                    <v-btn :width="125" :max-width="125" tile @click="SetDefaultLogo">default</v-btn>
                </v-list-item>
            </v-list-group>
            <v-list-group
              append-icon="none"
            >
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-btn :width="125" :max-width="125" tile color="primary">Send Event</v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Send event when startup</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item >
                    <v-text-field solo placeholder="DDN" v-model="startEventDDN" class="mr-4" hide-details></v-text-field>
                </v-list-item>
                <v-list-item >
                    <v-text-field solo placeholder="Topic" v-model="startEventTopic" class="mr-4" hide-details></v-text-field>
                </v-list-item>
                <v-list-item >
                    <v-text-field solo placeholder="Payload" v-model="startEventPayload" class="mr-4" hide-details></v-text-field>
                </v-list-item>
                <v-list-item >
                    <v-btn :width="125" :max-width="125" color="blue lighten-4" tile @click="setEvent">save</v-btn>
                </v-list-item>
            </v-list-group>
            <v-list-item>
              <v-list-item-action>
                <v-btn :width="125" :max-width="125" tile color="primary" @click="RestartWeb">Restart</v-btn>
              </v-list-item-action>
              <v-list-item-content>
                 <v-list-item-title>Restart the web</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>
<script>
//import Remote from '@/views/Remote'
export default {
    name:"SSTVConfig",
    data(){
        return {
            device:{},
            errCode:0,
            dropUrlDuration:null,
            setLogoUrl:'',
            startcmd:null,
            startcmd_droplast: true,
            startcmd_dropurl: false,
            droplastChanged: true,
            dropLastDelay:null,
            dropUrls:[],
            dropUrlMode:'',
            startEventDDN:'',
            startEventTopic:'',
            startEventPayload:'',
            errMsg:'',
            showErr:false,
            showScreenSetting:false,
            showConsole:false,
            enableStartupEvent:true,
            settingEiName:'',
            settingEiTag:'',
            settingEiLoc:'',
            showSetting:false,
            ddn:this.$route.params.ddn,
            rcerr:{
                "OK":{"code":0,"msg":"OK"},
                "Error":{"code":-499,"msg":"rc: error"},
                "InvalidData":{"code":-401,"msg":"rc: invalid data"},
                "InvalidCmd":{"code":-402,"msg":"rc: invalid command"},
                "Inactive":{"code":-403,"msg":"rc: mote inactive"},
                "MMSError":{"code":-404,"msg":"rc: mms error"}
            }
        }
    },
    props:['mms','mmsReady'],
    mixins:[],
    watch:{
        mmsReady(val){
            if(val){
                this.djControl('getevt', '', result => {
                    console.log(result);
                    if ( !this.chkReplyErr(result) ){
                        const reply=result[0].Reply;
                        if (reply){
                            console.log(reply);
                            let {DDN,Topic,Data} = reply.event;
                            this.startEventDDN=DDN;
                            this.startEventTopic=Topic;
                            this.startEventPayload=JSON.stringify(Data);
                        }
                    }
                });
                this.GetStartcmd();
                console.log(this.startcmd,this.enableStartupEvent);
            }
        }
    },
    methods:{
        deleteItem(arr,val){arr.splice(val,1)},
        getEiSettings(){
            this.touchControl('eisetting', 'get', result=>{
                console.log(result);
                let err = this.chkReplyErr(result);
                if ( !err ){
                    var reply = result[0].Reply;
                    console.log('getsetting reply=%s', JSON.stringify(reply));
                    if ( reply.EiName ) this.settingEiName=reply.EiName;
                    if ( reply.EiTag ) this.settingEiTag=reply.EiTag;
                    if ( reply.EiLoc ) this.settingEiLoc=reply.EiLoc;                    
                }
            });
        },
        setEiSettings(){
            let ei = {name:this.settingEiName,tag:this.settingEiTag,loc:this.settingEiLoc};
            
            this.touchControl('eisetting', ei, result=>{
                //console.log('eisetting result=%s', JSON.stringify(result));
                if(!this.chkReplyErr(result))this.showErr=true;
            });
        },
        SetStartEnable(){
            let cmd = (this.enableStartupEvent) ? 'enable' : 'disable';
            this.djControl(cmd, '', result=>{
                try {
                    if(!this.chkReplyErr(result))this.showErr=true;
                }
                catch(e){
                    console.log('SetStartEnable error=%s', e.message);
                }
            });
        },
        RestartWeb(){
            this.djControl('restart','', result=>{
                try {
                    if(!this.chkReplyErr(result))this.showErr=true;
                }
                catch(e){
                    console.log('RestartWeb error=%s', e.message);
                }
            });
        },
        dropLast(){
            let action = [];
            let delay = this.dropLastDelay;
            console.log('setlast delay=%s', delay);
            if ( delay ){
                let stcmd = {"cmd":{"cmd":"droplast"},"delay":delay};
                action.push(stcmd);
            }
            if ( action.length > 0 ){
                this.SetStartcmd(action);
            }
        },
        dropUrl(){
        //console.log('starcmd=%s', JSON.stringify(startcmd));
            let duration = this.dropUrlDuration;
            let pmode = this.dropUrlMode;
            let validUrls=this.dropUrls.filter(e=>/^https?:\/\//g.test(e));
            console.log(this.dropUrls,validUrls);
            //console.log('urls=%s,duration=%s,pmode=%s', JSON.stringify(urls), duration, pmode);
            if ( validUrls.length > 0 ){
                let stcmd = {"cmd":{"cmd":"drop","type":"url","src":validUrls,"duration":duration,"pmode":pmode}};
                console.log(stcmd);
                //console.log('stcmd=%s', JSON.stringify(stcmd));
                this.SetStartcmd(stcmd);
            }else{
                this.errCode=-401;
                this.errMsg='No valid urls.Have atleast one url and Urls should start with http.';
                this.showErr=true;
            }
        },
        SetLogo(url){
            if ( /^https?:\/\//g.test(url) ){ 
                this.djControl('logo',url, result=>{
                    try {
                        if ( !this.chkReplyErr(result) ){
                            let reply = result[0].Reply;
                            if ( reply ){
                                //console.log('SetStartcmd reply=%s', JSON.stringify(reply));
                                if ( reply.ErrCode == 0 ) {
                                    this.errMsg='Ok';
                                    this.GetStartcmd();
                                }
                                else {
                                    this.errMsg=reply.ErrMsg;
                                }
                                this.showErr=true;
                            }
                        }
                    }
                    catch(e){
                        console.log('RestartWeb error=%s', e.message);
                    }
                });
            }else{
                this.errCode=-401;
                this.errMsg='Invalid url.Url should start with http.';
                this.showErr=true;
            }
        },
        SetDefaultLogo(){
            this.djControl('deflogo', '', result=>{
                try {
                    console.log(result);
                    if(!this.chkReplyErr(result))this.showErr=true;
                }
                catch(e){
                    console.log('RestartWeb error=%s', e.message);
                }
            });
        },
        setEvent(){
            let data = {"DDN":this.startEventDDN,"Topic":this.startEventTopic,"Data":this.isJson(this.startEventPayload)?JSON.parse(this.startEventPayload):this.startEventPayload}
            this.djControl('setevt', data, (result) => {
                if (!this.chkReplyErr(result)) this.showErr=true;
            });
        },
        SetStartcmd(cmdarr){
            this.djControl('startcmd',cmdarr, result=>{
                try {
                    console.log(result);
                    if ( !this.chkReplyErr(result) ){
                        this.showErr=true;
                        this.GetStartcmd();
                    }
                }
                catch(e){
                    console.log('SetStartcmd error=%s', e.message);
                }
            });
        },
        GetStartcmd(cb){
            this.djControl('listcmd','', result=>{
                try {
                    if ( !this.chkReplyErr(result) ){
                        //console.log('GetStartcmd result=%s', JSON.stringify(result));
                        let reply = result[0].Reply;
                        if ( reply ){
                            console.log('GetStartcmd reply=%s', JSON.stringify(reply));
                            if ( !reply.ErrCode ){
                                if ( reply.response == 'listcmd' && reply.tasks.length > 0 ){
                                    let task = reply.tasks[0];
                                    if ( task.name == 'default' && task.trigger.type == 'onstart' && task.action ){
                                        console.log(task);
                                        if ( task.disable == false ) this.enableStartupEvent = true;
                                        else this.enableStartupEvent = false;
                                        this.startcmd = JSON.parse(JSON.stringify(task));
                                        //console.log('GetStartcmd startcmd=%s', JSON.stringify(startcmd));
                                        let action = task.action;
                                        //console.log('GetStartcmd action[0]=%s', JSON.stringify(action[0]));
                                        if ( action[0].payload.cmd == 'droplast' ) {
                                            this.startcmd_droplast = true;
                                            this.startcmd_dropurl = false;
                                            this.droplastChanged = true;
                                            this.dropLastDelay = action[0].delay;
                                        }
                                        else {
                                            this.startcmd_dropurl = true;
                                            this.startcmd_droplast = false;
                                            this.dropurlChanged = true;
                                            this.dropUrls=[];
                                            this.dropUrlDuration=action[0].cmd.duration;
                                            this.dropUrlMode=action[0].cmd.pmode;
                                            action[0].cmd.src.forEach(e=>this.dropUrls.push(e));
                                        }
                                        //console.log('GetStartcmd disable=%s,droplast=%s,dropurl=%s', startcmd_disable, startcmd_droplast, startcmd_dropurl);
                                        if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.OK.code,"ErrMsg":rcerr.OK.msg});
                                    }
                                }
                                else {
                                    if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.InvalidData.code,"ErrMsg":rcerr.InvalidData.msg});
                                }
                            }
                            else {
                                this.errMsg=reply.ErrMsg;
                                this.showErr=true;
                                if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.Inactive.code,"ErrMsg":rcerr.Inactive.msg});
                            }
                        }
                        else {
                            if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.Inactive.code,"ErrMsg":rcerr.Inactive.msg});
                        }
                    }
                    else {
                        if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.MMSError.code,"ErrMsg":rcerr.MMSError.msg});
                    }
                }
                catch(e){
                    console.log('GetStartcmd error=%s', e.message);
                }
            });
        },
        djControl(action, value, cb){
            let ddn = this.ddn;
            if ( ddn && action ){
                var djcmd = {"cmd":"dj","option":action,"value":value};
                //console.log('djControl ddn=%s,cmd=%s', ddn, JSON.stringify(djcmd));
                this.mms.sendMMS( {DDN:'ddn/'+ddn,topic:'', payload:this.isJson(djcmd)?JSON.parse(djcmd):djcmd}).then(result=>{
                        //console.log('touchControl: send result=%s',JSON.stringify(result));
                        if ( typeof cb == 'function' ) cb(result);
                    });   
            }
            else {
                if ( typeof cb == 'function' ) cb({"ErrCode":rcerr.InvalidData.code,"ErrMsg":rcerr.InvalidData.msg});
            }
        },
        consoleControl(action, value, cb){
            // action: onoff, clear, scrollup, scrolldown
            var tcmd = {"cmd":"touch","option":action,"value":value};
            if ( tcmd.option != '' ){
                let target = this.ddn;
                if ( target != '' ){
                    target = 'ddn/' + target
                    //console.log('consoleControl target=%s,cmd=%s', target, JSON.stringify(tcmd));
                    this.mms.sendMMS( {DDN:target,topic:'', payload:this.isJson(tcmd)?JSON.parse(tcmd):tcmd}).then(result=>{
                        //console.log('touchControl: send result=%s',JSON.stringify(result));
                        if ( typeof cb == 'function' ) cb(result);
                    });   
                }
            }
        },
        touchControl(action, value, cb){
            var tcmd = {"cmd":"touch","option":action,"value":value};
            if ( tcmd.option != '' ){
                let target = this.ddn;
                if ( target != '' ){
                    target = 'ddn/' + target;
                    console.log(target,tcmd);
                    //var wstr = target + ' ' + JSON.stringify(tcmd);
                    //console.log('settingControl target=%s,cmd=%s', target, JSON.stringify(tcmd));
                    this.mms.sendMMS( {DDN:target,topic:'', payload:this.isJson(tcmd)?JSON.parse(tcmd):tcmd}).then(result=>{
                        //console.log('settingControl: send result=%s',JSON.stringify(result));
                        if ( typeof cb == 'function' ) cb(result);
                    });   
                }
            }    
        },
        chkReplyErr(data){
            var err = true;
            try {
                if ( data ){
                    if ( Array.isArray(data) ) {
                        let xstate = data[0].IN.State;
                        this.errCode=xstate.ErrCode;
                        if ( xstate.ErrCode != 0 ) this.errMsg = xstate.ErrMsg;
                        else {
                            let reply = data[0].Reply;
                            if ( !reply ) this.errMsg = 'no reply data';
                            else err = false;
                        }
                    }
                    else {
                        this.errMsg = data.ErrMsg;
                    }
                }
            }
            catch(e){
                this.errMsg = e.message;
            }
            if ( err ) {
                console.log('mms error=%s', this.errMsg);
                this.showErr=true;
            }else this.errMsg='Ok';
            
            return err;
        }
    },
    async created(){
    }
}
</script>




